import { render } from "./BlockMetricsChart.vue?vue&type=template&id=fe2941a6&scoped=true"
import script from "./BlockMetricsChart.vue?vue&type=script&lang=js"
export * from "./BlockMetricsChart.vue?vue&type=script&lang=js"

import "./BlockMetricsChart.vue?vue&type=style&index=0&id=fe2941a6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2941a6"],['__file',"resources/js/components/BlockMetricsChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe2941a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe2941a6', __exports__)) {
    api.reload('fe2941a6', __exports__)
  }
  
  module.hot.accept("./BlockMetricsChart.vue?vue&type=template&id=fe2941a6&scoped=true", () => {
    api.rerender('fe2941a6', render)
  })

}


export default __exports__